import { AccountFilters } from "../types";
import { AccountsFilters } from "../types/enums";

export const prepareFilters = (data?: AccountFilters) => {
  if (!data) return [];

  const keys = Object.keys(data);

  return [
    ...keys
      .filter((key) => data[key as keyof AccountFilters].length > 0)
      .map((key: string) => {
        return {
          placeholder: AccountsFilters[key as keyof AccountFilters],
          query: key,
          items: data[key as keyof AccountFilters],
        };
      }),
  ];
};
